import React from "react";

interface Props extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  bold?: boolean;
}

function SmallDetail(props: Props) {
  const { className, bold, ...otherProps } = props;
  const classNames = `${className || ""} small-detail ${bold ? "bold" : ""}`;

  return (
    <div className={classNames} {...otherProps}>
      {props.children}
    </div>
  );
}

export default SmallDetail;
